// src/context/AuthContext.tsx
import api from "../api/api";
import { ExemplarResponse } from "../types/ExemplarResponse"; // DTO im Frontend

export const SuchContext = async (params: {
  id?: number;
  titel?: string;
  autor?: string;
  kategorie?: string;
  isbn?: string;
}): Promise<ExemplarResponse[]> => {
  try {
    const res = await api.get<ExemplarResponse[]>("/suche", {
      params,
    });
    return res.data;
  } catch (err) {
    console.error("Buchsuche fehlgeschlagen:", err);
    return [];
  }
};
